var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H10C4.47715 0 0 4.47715 0 10V29C0 34.5228 4.47715 39 10 39H30C35.5228 39 40 34.5228 40 29V10C40 4.47715 35.5228 0 30 0Z",
    fill: "url(#paint0_linear_1628_1604)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2796 32.155C14.1692 32.1538 14.0608 32.1261 13.9634 32.0743C13.866 32.0224 13.7825 31.9479 13.72 31.857C13.6574 31.7662 13.6176 31.6616 13.604 31.5521C13.5903 31.4426 13.6032 31.3314 13.6416 31.228L17.0646 22.176H13.1466C13.0113 22.1759 12.879 22.1357 12.7666 22.0605C12.6541 21.9853 12.5665 21.8784 12.5148 21.7533C12.4631 21.6283 12.4496 21.4908 12.4761 21.3581C12.5026 21.2254 12.5678 21.1036 12.6636 21.008L25.8896 7.86095C25.9988 7.75155 26.142 7.68253 26.2957 7.66519C26.4493 7.64785 26.6043 7.68324 26.7352 7.76554C26.866 7.84784 26.9651 7.97217 27.016 8.11815C27.067 8.26412 27.0668 8.42308 27.0156 8.56895L23.8736 17.634H27.8216C27.9577 17.6338 28.0908 17.6743 28.2037 17.7502C28.3167 17.8261 28.4045 17.934 28.4558 18.06C28.5072 18.1861 28.5197 18.3246 28.4919 18.4578C28.464 18.5911 28.3971 18.713 28.2996 18.808L14.7576 31.961C14.6287 32.0841 14.4578 32.1535 14.2796 32.155Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1628_1604",
    x1: -1.96,
    y1: -7.371,
    x2: 37.0991,
    y2: 41.8793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1652F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16FF81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.3e93add9d3535e76375af855530cb5d1.svg";
export { ForwardRef as ReactComponent };